//remove default shopify class
let page_container = document.getElementById('PageContainer')
if(page_container)
page_container.classList.remove('page-container')

//Get Banners, Diamond list, Wrapper
let root = document.querySelector(':root');

let extra = 0
let main_content = document.getElementById('MainContent')
main_content.style.paddingTop = '0px'
let wrapper = document.getElementById('Customize-Wrapper')
let banner_section = document.getElementById('Customize-Banner-Section')
let diamond_list = document.getElementById('Diamond-List-Container')
let banner2 = document.getElementById('Customize-Banner-Container-2')
let banner3 = document.getElementById('Customize-Banner-Container-3')
let announcement_bar = document.querySelector('.announcement-bar')
let announcement_bar_height = 0
let is_necklace = false

///ORIGINAL HEADER 
if(announcement_bar){
  //hide annocement bar
  // announcement_bar.style.display = 'none'
  // announcement_bar_height = announcement_bar.getBoundingClientRect().height

}
let header_element = document.querySelector('header')
let header_element_height = 0
if(header_element){
  //hide original header
  // header_element.style.display = 'none'
  // header_element_height= header_element.getBoundingClientRect().height
}
let header_total = header_element_height + announcement_bar_height

// //NEW NAV
let new_nav_total = 58.5

root.style.setProperty('--navHeight', new_nav_total + 'px');




let banner_section_pos_bot = banner_section.getBoundingClientRect().bottom



let my_ring_name = document.getElementById('Customize-Banner-My-Ring-Details-Name')
let my_ring_metal = document.getElementById('Customize-Banner-My-Ring-Details-Metal')
let my_ring_size = document.getElementById('Customize-Banner-My-Ring-Details-Size')
let my_ring_img = document.getElementById('Customize-Banner-My-Ring-Details-Img')
let my_ring_modify = document.getElementById('Customize-Banner-My-Ring-Details-Modify')


let url = new URL(location.href)
let name = url.searchParams.get('name')

let shape = url.searchParams.get('shape')
let size = url.searchParams.get('size')
let metal = url.searchParams.get('metal')
let ring_img = url.searchParams.get('ring_img')
let engravings = url.searchParams.get('engravings')
let handle = url.searchParams.get('handle')
let d1 = url.searchParams.get('d1')
let d2 = url.searchParams.get('d2')
let main_is_all_cut = false
let diamond_type = url.searchParams.get('natural')

if(shape.toLowerCase() == 'all cut'){
  //display fluorescent filter
  document.getElementById('Filter-Section-Fluorescent').style.display = 'block'
  main_is_all_cut = true
  document.getElementById('Customize-Banner-My-Ring-Img-Contaier-ID').style.opacity = 0
  let my_ring_details = document.getElementById('Customize-Banner-My-Ring-Details-ID')
  Array.from(my_ring_details.querySelectorAll('div')).forEach(div=>div.style.visibility="hidden")
  my_ring_details.style.left = '20px'
  if(window.innerWidth <= 750){
    my_ring_details.style.height = '40px'
  }
  let details_first_child = my_ring_details.querySelector('div')
  details_first_child.innerText = 'Diamond Selector'
  details_first_child.style.visibility="visible"
  document.getElementById('Filter-Intro-Container').style.display = 'none'
}

if(size != 'null' && size !== null){
  my_ring_size.innerText = 'Size: ' + size
} else {
  my_ring_size.style.visibility = 'hidden'
}

if(window.innerWidth > 750){
  my_ring_name.innerText = name + ', ' + shape
} else {
  my_ring_name.innerHTML = name + ', <br>' + shape
}

my_ring_metal.innerText = 'Metal: ' + metal
my_ring_img.src = ring_img



my_ring_modify.addEventListener('click',()=>{
  location.href = '/products/'+ handle +'?metal=' + metal +'&size=' + size + '&engravings=' + encodeURIComponent(engravings) + '&modify=Y&earring=true&d1=N&d2=N'  
})






if(window.innerWidth < 1296){
  //smaller windows, require diamond list to a little higher than on normal/wide windows
  extra = 10
}


//change title for earrings
if(url.searchParams.get('earrings') == 'true'){
  document.getElementById('Customize-Banner-My-Ring-Details-Title').innerText = 'Your Earrings'
}

//change title for necklace //temp solution
if(url.searchParams.get('name')){
  if(url.searchParams.get('name').toLowerCase().includes('necklace')){
    is_necklace = true
    document.getElementById('Customize-Banner-My-Ring-Details-Title').innerText = 'Your Necklace'
  } else if(url.searchParams.get('name').toLowerCase().includes('montevalle bracelet diamond')){
    is_necklace = true
    document.getElementById('Customize-Banner-My-Ring-Details-Title').innerText = 'Your Bracelet'
  }
}







//on smaller windows, change position of banners/column header
if(window.innerWidth < 1296){
  document.addEventListener("scroll", (event) => {
    if(window.scrollY >= 300){
      banner2.style.top = '57px'
      banner2.style.width = '100%'
      banner2.style.position = 'fixed'

      banner3.style.top = '162px'
      banner3.style.position = 'fixed'
    } else {
      banner2.style.top = 'initial'
      banner2.style.position = 'initial'
      banner3.style.top = 'initial'
      banner3.style.position = 'initial'
    }
  });
}


//set initial position of diamond list
let diamond_list_top = banner_section_pos_bot - header_total - extra - new_nav_total
diamond_list.style.marginTop = diamond_list_top + 'px'

//set intial height of page wrapper
//load empty row //row height 72px
wrapper.style.height = diamond_list_top + (72*1) + new_nav_total + 'px'
main_content.style.height = window.innerHeight - header_total + 'px'
main_content.style.transition = 'height .5s ease'


// let interval_count = 0 
// let interval_instance = setInterval(()=>{
//   turnOffCurrencyConverter()
// },50)

// function turnOffCurrencyConverter(){
//   interval_count = interval_count + 1
//   let shopify_currency_converter = document.querySelector('.buckscc-floating-box')
//   if(shopify_currency_converter){
//     shopify_currency_converter.style.position = 'absolute'
//     shopify_currency_converter.style.zIndex = '-1'
//     clearInterval(interval_instance)
//   }

//   if(interval_count > 200){
//     clearInterval(interval_instance)
//   }

// }


// function convertToSlug(Text) {
//   return Text.toLowerCase().replace(/ /g,'-').replace(/[-]+/g, '-').replace(/[^\w-]+/g,'');
// }


//NAV
document.getElementById('Customize-Go-Back-Btn').addEventListener('click',()=>{
  if(main_is_all_cut){
    location.href = '/'
  } else{
    location.href = '/products/'+ handle +'?metal=' + metal +'&size=' + size + '&engravings=' + encodeURIComponent(engravings) + '&modify=Y'
  }
})

//large img /3d viewer
let viewer_container = document.getElementById('Customize-Large-Img-And-3d-Container') 
let viewer_exit = document.getElementById('Customize-Large-Img-And-3d-Exit')

viewer_exit.addEventListener('click',()=>{
  viewer_container.style.display = 'none'
})


//Diamond Type
if(window.innerWidth > 750){
  if(diamond_type == '1'){
    document.getElementById('Color-I').style.marginLeft = '-7px'
    document.getElementById('Color-G').style.marginLeft = '3px'
  }

}

if(diamond_type == '1'){
  //display fluorescent filter
  document.getElementById('Filter-Section-Fluorescent').style.display = 'block'
  document.getElementById('Customize-Banner2-Title-Diamond-Type').innerText = 'Natural'
  root.style.setProperty('--columnHeaderColor', '#ccb763');
  root.style.setProperty('--columnRowHighlight', '#FFF9EB');
  root.style.setProperty('--columnRowHover', '#ccb763');
  root.style.setProperty('--filterCertActiveColor', '#ccb763');
  root.style.setProperty('--filterCertActiveFontColor', '#000');
}

